export const CANVAS_WIDTH = 800;
export const CANVAS_HEIGHT = 600;

export const CERTIFICATE_FIELDS = [
  'title',
  'learner_name',
  'course_name',
  'completion_date',
  'score'
];

export const DEFAULT_LAYOUT = {
  title: { x: 400, y: 150, fontSize: 36, color: '#000000' },
  learner_name: { x: 400, y: 250, fontSize: 28, color: '#000000' },
  course_name: { x: 400, y: 320, fontSize: 20, color: '#000000' },
  completion_date: { x: 400, y: 380, fontSize: 16, color: '#000000' },
  score: { x: 400, y: 420, fontSize: 16, color: '#000000' }
};

export const parseLayoutConfig = (layoutConfig) => {
  if (!layoutConfig) {
    return { ...DEFAULT_LAYOUT };
  }

  let parsed = layoutConfig;
  if (typeof layoutConfig === 'string') {
    try {
      parsed = JSON.parse(layoutConfig);
    } catch {
      return { ...DEFAULT_LAYOUT };
    }
  }

  return {
    ...DEFAULT_LAYOUT,
    ...(parsed && typeof parsed === 'object' ? parsed : {})
  };
};

export const formatCompletionDate = (completionDate) => {
  if (!completionDate) return '';
  return new Date(completionDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const getCertificateFieldText = (fieldKey, data = {}) => {
  switch (fieldKey) {
    case 'title':
      return 'Certificate of Completion';
    case 'learner_name':
      return data.learner_name || '';
    case 'course_name':
      return data.course_name || '';
    case 'completion_date':
      return data.completion_date
        ? formatCompletionDate(data.completion_date)
        : (data.completion_date_label || '');
    case 'score':
      if (data.score !== undefined && data.score !== null && data.score !== '') {
        return String(data.score).includes('%') ? String(data.score) : `${data.score}%`;
      }
      if (data.score_percentage !== null && data.score_percentage !== undefined && data.score_percentage !== '') {
        return `${parseFloat(data.score_percentage)}%`;
      }
      return '';
    default:
      return '';
  }
};

export const SAMPLE_CERTIFICATE_DATA = {
  learner_name: 'John Doe',
  course_name: 'Sample Course Title',
  completion_date: new Date().toISOString().split('T')[0],
  score_percentage: 95
};
